var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.288 14.775L17.763 6.3C17.963 6.1 18.1963 6 18.463 6C18.7297 6 18.963 6.1 19.163 6.3C19.363 6.5 19.463 6.7375 19.463 7.0125C19.463 7.2875 19.363 7.525 19.163 7.725L9.988 16.925C9.788 17.125 9.55467 17.225 9.288 17.225C9.02133 17.225 8.788 17.125 8.588 16.925L4.288 12.625C4.088 12.425 3.99217 12.1875 4.0005 11.9125C4.00883 11.6375 4.113 11.4 4.313 11.2C4.513 11 4.7505 10.9 5.0255 10.9C5.3005 10.9 5.538 11 5.738 11.2L9.288 14.775Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckM);
export default __webpack_public_path__ + "static/media/check-m.f63aff417baa7f23b9ef66d5048605da.svg";
export { ForwardRef as ReactComponent };